import { Table } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { translate } from "app/filters/i18nFilter";

import { GrowthOverviewExportButtons } from "../controls/GrowthOverviewExportButtons";
import { GrowthOverviewHeaderExtensions } from "../controls/GrowthOverviewHeaderExtensions";
import { GROWTH_OVERVIEW_I18N_KEYS } from "../growthOverviewTexts";

interface IGrowthOverviewTableTopProps {
    subtitleFilters: ReturnType<typeof useSubtitleFilters>;
    searchTerm: string;
    onSearchChange: (term: string) => void;
    totalCount: number;
}

export const GrowthOverviewTableTop = ({
    subtitleFilters,
    searchTerm,
    onSearchChange,
    totalCount,
}: IGrowthOverviewTableTopProps) => (
    <Table.TableTop borderBottom>
        <Table.TableTop.Title
            title={translate(GROWTH_OVERVIEW_I18N_KEYS.title)}
            tooltip={translate(GROWTH_OVERVIEW_I18N_KEYS.titleTooltip)}
            filters={[...subtitleFilters]}
            extensions={<GrowthOverviewHeaderExtensions />}
        />
        <Table.TableTop.Filters
            filters={[
                {
                    filter: "search",
                    initialValue: searchTerm,
                    onSearchChange,
                    placeholder: translate(GROWTH_OVERVIEW_I18N_KEYS.searchPlaceholder),
                },
            ]}
            factoryFilters={
                <Flex
                    flex="1"
                    justifyContent="flex-end"
                    alignItems="center"
                >
                    <GrowthOverviewExportButtons totalCount={totalCount} />
                </Flex>
            }
        />
    </Table.TableTop>
);
